<template>
  <div>
    <div class="modal-body">
      <p>As instruções para redefinir a senha serão enviadas para o e-mail abaixo:</p>
      <input
        ref="current-student-email"
        v-model="newEmail"
        :readonly="keepSameEmail"
        class="form-input"
        type="email"
      >
      <label class="data-confirmation__checkbox-wrapper">
        <input
          ref="keep-same-email"
          v-model="keepSameEmail"
          :value="keepSameEmail"
          type="checkbox"
        >
        Manter o mesmo e-mail
      </label>
    </div>

    <div class="modal-footer">
      <button
        class="btn btn-primary"
        @click="sendResetPassword"
      >
        {{ keepSameEmail === true ? "Enviar" : "Alterar e-mail e enviar" }}
      </button>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex';
import ResetPasswordService from 'services/ResetPasswordService';
import StudentsService from 'services/StudentsService';

export default {
  data() {
    return {
      newEmail: this.currentStudentEmail,
      keepSameEmail: true,
    };
  },
  props: {
    currentStudentEmail: {
      type: String,
      required: true,
      default: '',
    },
  },
  computed: {
    ...mapState(['student']),
  },
  methods: {
    sendResetPassword() {
      this.$loader.show();
      if (this.keepSameEmail) {
        this.createResetPassword();
        return;
      }
      this.updateStudentEmail();
    },
    createResetPassword() {
      const { cpf } = this.student;
      ResetPasswordService.createResetPassword(cpf)
        .then(({ data }) => {
          const { reset_url: resetUrl } = data;
          this.$emit('showEmailDelivered', resetUrl);
        })
        .catch(({ response }) => {
          const { message } = response.data;
          this.$alert.notifyAlert(`Falha ao enviar o e-mail: ${message}`);
        }).finally(() => {
          this.$loader.hide();
        });
    },
    updateStudentEmail() {
      StudentsService.saveStudentData({
        ...this.student,
        email: this.newEmail,
      })
        .then(() => {
          this.$emit('updateStudentEmail', this.newEmail);
          this.createResetPassword();
        })
        .catch(({ response }) => {
          this.$alert.notifyAlert(`Falha ao salvar dados do aluno: ${response.data.message}`);
          this.$loader.hide();
        });
    },
  },
};
</script>
<style scoped lang="scss">
@import 'assets/stylesheets/utils/_spacing.sass';

.data-confirmation__checkbox-wrapper {
  cursor: pointer;
  margin-top: $space-m;
}
</style>
